import {
  EntityDto,
  EntityValidationResponse,
  EntityValidatorDto,
  ItemValidatorDto,
} from '../models';

export const mockValidatorEntity: EntityDto = {
  entityId: '1',
  entityType: 'list',
};

export const mockValidatorItem: ItemValidatorDto = {
  id: 1,
  name: 'multiplyNumberOfPackages',
  validatorContext: {
    value: true,
  },
};

export const mockValidationOperators = {
  itemsToAdd: [],
  itemsToUpdate: [mockValidatorItem],
  itemsToDelete: [],
};

export const mockEntityWithValidatorOperators: EntityValidatorDto = {
  ...mockValidatorEntity,
  validators: mockValidationOperators,
};

export const mockValidationResponse: EntityValidationResponse = {
  ...mockValidatorEntity,
  validators: [mockValidatorItem],
};
